import layout from "../layout"
// const Login = () => import("../views/login/index.vue")
// const notFound = () => import("../views/404.vue")
// const Main = () => import("../views/mainPage/index.vue")

import Login from "../views/login"
import notFound from "../views/404.vue"
import Main from "../views/mainPage/index"

import member from "../views/authorization/member/index.vue"
import organization from "../views/authorization/organization/index.vue"
import resource from "../views/authorization/resource/index.vue"
import resourceGroup from "../views/authorization/resourceGroup/index.vue"
import page403 from "../views/403.vue";
import Test from "../views/test"

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/main",
    name: "main",
    component: Main,
  },
  {
    path: "/authority",
    redirect: "/authority/management/user",
    component: layout,
    name: "authority_server",
    icon: "quanxian-shuangse",
    children: [
      {
        path: "/test",
        name: "test",
        component: Test
      },
      {
        path: "/authority/management/user",
        component: member,
        name: "user_management",
        // auth: "user_management",
        meta: { requireAuth: true },//进入这个路由需要权限
      },
      {
        path: "/authority/management/organization",
        component: organization,
        name: "organization_management",
        // auth: "organization_management",
      },
      {
        path: "/authority/management/resource",
        component: resource,
        name: "resource_management",
        // auth: "resource_management",
        meta: {},
      },
      {
        path: "/authority/management/resGroup",
        component: resourceGroup,
        name: "role_management",
        // auth: "role_management",
        meta: {},
      },
    ],
  },
  {
    path: "/403",
    name: "noRight",
    component: page403,
  },
  {
    path: "/404",
    name: "notFound",
    component: notFound,
  },
  {
    path: "/",
    redirect: "/login"
  },
  {
    path: "*", // 此处需特别注意置于最底部
    redirect: "/404",
  },
];

export default routes

